import { createAction } from 'redux-act';
export const ACTIVE_MENU = createAction('ACTIVE_MENU');
export const ACTIVE_TAB_MEDIA = createAction('ACTIVE_TAB_MEDIA');
export const ACTIVE_TAB_TENANT = createAction('ACTIVE_TAB_TENANT');


export const SET_POI_CATEGORY = createAction('SET_POI_CATEGORY');
export const SET_POI_TAG = createAction('SET_POI_TAG');
export const SET_POI_FLOOR = createAction('SET_POI_FLOOR');
export const SET_POI_LINK_FILTER = createAction('SET_POI_LINK_FILTER');

export const SET_INFO_CATEGORY = createAction('SET_INFO_CATEGORY');

export const FILTER_CLEAN_UP = createAction('FILTER_CLEAN_UP');

export const setBreadcrumb = (list) => {
  return async (dispatch, getState) => {
    return dispatch(ACTIVE_MENU({ list }));
  };
};

export const setTabMedia = (media) => {
  return async (dispatch, getState) => {
    return dispatch(ACTIVE_TAB_MEDIA({ media }));
  };
};

export const setTabTenant = (tenant) => {
  return async (dispatch, getState) => {
    return dispatch(ACTIVE_TAB_TENANT({ tenant }));
  };
};

export const setPoiCategory = (data) => {
  return (dispatch) => {
    dispatch(SET_POI_CATEGORY({ data }));
  };
};

export const setPoiTag = (data) => {
  return (dispatch) => {
    dispatch(SET_POI_TAG({ data }));
  };
};

export const setPoiFloor = (data) => {
  return (dispatch) => {
    dispatch(SET_POI_FLOOR({ data }));
  };
};

export const setPoiLinkFilter = (data) => {
  return (dispatch) => {
    dispatch(SET_POI_LINK_FILTER({ data }));
  };
};

export const setInfoCategory = (data) => {
  return (dispatch) => {
    dispatch(SET_INFO_CATEGORY({ data }));
  };
};



export const filterCleanUp = () => (dispatch) => dispatch(FILTER_CLEAN_UP());
